import * as actions from '../actionTypes'

// pageDocs is { first: <doc>, last: <doc> } for that page, and used by prev/next
const initialState = { 
    value: []
}

export default function storyPromptGridPageDocs(state = initialState, action) {

    switch(action.type) {

        case actions.SET_STORY_PROMPT_GRID_PAGE_DOCS: {

            //console.log('[redux] Setting story prompt grid page docs value', action.payload.value)
            return {
                ...state,
                value: action.payload.value
            }
        }

        default:
            return state
    }
}